const tokenKey = 'token'

class JwtService {
  private token: string | null = null

  public saveToken = (token: string) => {
    localStorage.setItem(tokenKey, token)
    this.token = token
    // Дашборды (Hangfire/Serilog UI) открываются обычной ссылкой в браузере — Bearer из
    // localStorage в таком запросе нет. Кладём токен в куку: бэкенд-мост переносит её в
    // Authorization и валидирует через OpenIddict (Admin-гейт). Одна кука гейтит оба дашборда.
    document.cookie = `hangfire_token=${token}; path=/; samesite=strict`
  }

  public getToken = () => {
    if (this.token != null) {
      return this.token
    }

    this.token = localStorage.getItem(tokenKey) as string | null
    return this.token
  }

  public clear = () => {
    this.token = null
    localStorage.removeItem(tokenKey)
    // Гасим куку доступа к дашбордам при выходе.
    document.cookie = 'hangfire_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}
export default new JwtService()
